import { getReq } from 'api';
import { NextSeo } from 'next-seo';
import SEO from 'next-seo.config';
import SidebarLayout from 'layouts/SidebarLayout';
import auth from 'utils/auth';
import { wrapper } from 'store';
import Typo from 'components/Typo';
import { feed } from 'lang/en.json';

import styles from 'styles/modules/Feed.module.scss';
import FeedList from 'components/Feed/List';

const Feed = ({ data, isAuthenticated = false }) => {
    return (
        <>
            <NextSeo {...SEO} titleTemplate={`${feed.title} | %s`} />
            <SidebarLayout isAuthenticated={isAuthenticated}>
                <div className={styles.wrapper}>
                    <div className={styles.titleWrapper}>
                        <Typo variant={'h1'}>{feed.title}</Typo>
                    </div>
                    <div className={styles.divider} />
                    {
                        <div className={styles.listWrapper}>
                            <FeedList data={data.alerts} type="alert" />
                            <FeedList data={data.stories} type="story" />
                        </div>
                    }
                </div>
            </SidebarLayout>
        </>
    );
};

export const getServerSideProps = wrapper.getServerSideProps(
    (store) =>
        async ({ req, res, params }) => {
            const { data } = await getReq('/newspage/feed');

            await auth(store, req, res, params);
            return {
                props: {
                    data: data.data,
                    isAuthenticated: store.getState().auth.isAuthenticated,
                },
            };
        }
);

export default wrapper.withRedux(Feed);
